/**
 * 我的任务总路由
 * 2019-05-08
 * Qian.qianchen
 */
"use strict";
angular.module("myAssignmentsRouterModule", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.state("front.plan.taskassignment.myassignments.myallassignments", {
        url: "/myallassignments", //所有任务
        views: {
            "main@front.plan.taskassignment.myassignments": {
                templateUrl: "./planningCenter/taskAssignment/myAssignments/myAllAssignments/myAllAssignments_tpl.html",
                controller: "myAllAssignmentsCtrl"
            }
        }
    }).
    state("front.plan.taskassignment.myassignments.executeassignments", {
        url: "/executeassignments", //执行任务
        views: {
            "main@front.plan.taskassignment.myassignments": {
                templateUrl: "./planningCenter/taskAssignment/myAssignments/executeAssignments/executeAssignments_tpl.html",
                controller: "executeAssignmentsCtrl"
            }
        }
    }).
    state("front.plan.taskassignment.myassignments.assignmentedit", { //新建/编辑任务
        url: '/assignmentedit?assignmentid&platform',
        views: {
            "main@front.plan.taskassignment": {
                templateUrl: "./planningCenter/taskAssignment/editAssignment/editAssignment_tpl.html",
                controller: "editAssignmentCtrl"
            }
        }
    });
}]);